import clsx from 'clsx';

import { SubscribeSection as SubscribeSectionProps, SanityKeyed } from 'types/studio/studio';

import { Container, Space, Typography, getTypographyDefaultColor } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';

import { SubscribeSectionForm } from './SubscribeSectionForm';
import { CommonSectionProps } from '../types';

import styles from './SubscribeSection.module.scss';

const SubscribeSection = (props: SanityKeyed<SubscribeSectionProps> & CommonSectionProps) => {
  const {
    headline,
    subtitle,
    placeholder,
    buttonLabel,
    successButtonLabel,
    errorMessage,
    theme,
    padding,
    _key: key,
    _type: sectionType
  } = props;

  return (
    <Space
      top={{ xxs: 40, l: 80 }}
      bottom={{ xxs: 40, l: 80 }}
      className={clsx(getSectionPaddingClasses(styles, padding))}>
      <Container narrow id={key}>
        <div className={clsx(styles.containerChild, getThemeCSSClass(theme))}>
          <Space top={{ xxs: 72, s: 56, m: 64, l: 100 }} bottom={{ xxs: 80, s: 56, m: 64, l: 100 }}>
            <div className={styles.content}>
              <div className={styles.textBlock}>
                <Typography
                  variant="headline"
                  size="2"
                  noPadding
                  color={getTypographyDefaultColor(theme)}>
                  <CustomPortableText value={headline} />
                </Typography>
                {subtitle && (
                  <Typography
                    variant="subtitle"
                    size="1"
                    noPadding
                    weight="700"
                    color={getTypographyDefaultColor(theme)}>
                    <CustomPortableText value={subtitle} />
                  </Typography>
                )}
              </div>
              <SubscribeSectionForm
                className={styles.form}
                placeholder={placeholder}
                buttonLabel={buttonLabel}
                successButtonLabel={successButtonLabel}
                errorMessage={errorMessage}
                theme={theme}
                _type={sectionType}
              />
            </div>
          </Space>
        </div>
      </Container>
    </Space>
  );
};

export default SubscribeSection;
